import { motion } from "framer-motion";

const word = {
  hidden: { y: "105%", opacity: 0 },
  show: (i) => ({ y: "0%", opacity: 1, transition: { duration: 0.8, delay: 0.05 * i, ease: [0.22, 1, 0.36, 1] } }),
};

export const Words = ({ words, hl = [], hlClass = "hl", render }) =>
  words.map((w, i) => (
    <span key={i}>
      <span className="inline-block overflow-hidden pb-[0.06em] align-bottom">{render(w, i, hl.includes(i) ? hlClass : "")}</span>
      {i < words.length - 1 ? " " : ""}
    </span>
  ));

export const Kinetic = ({ text, hl = [], hlClass = "hl", as: Tag = "h2", className = "", testId, animateOnMount = false }) => {
  const trigger = animateOnMount ? { animate: "show" } : { whileInView: "show", viewport: { once: false, amount: 0.5 } };
  return (
    <Tag className={className} data-testid={testId}>
      <motion.span initial="hidden" {...trigger} className="block">
        <Words
          words={text.split(" ")}
          hl={hl}
          hlClass={hlClass}
          render={(w, i, cls) => (
            <motion.span custom={i} variants={word} className={`inline-block ${cls}`}>
              {w}
            </motion.span>
          )}
        />
      </motion.span>
    </Tag>
  );
};

export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: false, amount: 0.2 }}
    transition={{ duration: 0.75, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ eyebrow, title, hl, dark = false, hlClass, className = "", testId, children }) => (
  <div className={className}>
    <Reveal>
      <span className={`eyebrow ${dark ? "eyebrow-dark" : ""}`}>{eyebrow}</span>
    </Reveal>
    <Kinetic
      text={title}
      hl={hl}
      hlClass={hlClass}
      testId={testId}
      className={`display mt-5 text-4xl leading-[0.98] sm:text-5xl lg:text-6xl ${dark ? "text-white" : "text-ink"}`}
    />
    {children}
  </div>
);
